import type { InsightsReportResource } from "@octopusdeploy/octopus-server-client";
import { InsightsMetricsSplitValues } from "@octopusdeploy/portal-routes";
import type { ReportMetricsPageProps } from "app/areas/insights/components/Reports/ReportMetricsLayout/ReportMetricsLayout";
import { ReportMetricsLayout } from "app/areas/insights/components/Reports/ReportMetricsLayout/ReportMetricsLayout";
import React, { useEffect } from "react";
import { useAnalyticSimpleActionDispatch } from "~/analytics/Analytics";
import { InsightsReportLayout } from "~/areas/insights/components/InsightsReportLayout/InsightsReportLayout";
import { useReportFilters } from "~/areas/insights/components/Reports/ReportMetricsLayout/useReportFilters";
import { getChartAxisDateFormatter } from "../../dataTransformation/dateHelpers";
import { getChartReadyInsightsData } from "../../dataTransformation/getChartReadyInsightsData";
import { getEvenlySpacedTickArray } from "../../dataTransformation/getYAxisDataMax";
import { insightsCadenceLookup, insightsCadenceXAxisTickInterval } from "../../insightsCadence";
import { InsightsTooltip } from "../ChartTooltips/InsightsTooltip/InsightsTooltip";
import LineChart from "../Charts/LineChart";
import { DownloadReportCsvButton } from "../DownloadReportCsvButton";
import { InsightsChartCard } from "../InsightsChartCard";
import { FailureRateTrendTables } from "./TrendTables/FailureRateTrendTables";
type Props = ReportMetricsPageProps;
export function ReportDeploymentFailureRateInner({ report, bffResponse, split, cadence, busy }: Props) {
    const dispatchAction = useAnalyticSimpleActionDispatch();
    const chartData = getChartReadyInsightsData(bffResponse.Series);
    const currentGranularity = insightsCadenceLookup[cadence].granularity;
    const dateFormatter = getChartAxisDateFormatter(currentGranularity);
    const showSeries = split !== InsightsMetricsSplitValues.None;
    useEffect(() => {
        dispatchAction("View Insights Report Deployment Failure Rate");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (<main>
            <section style={{ padding: "0rem 1rem 2rem" }}>
                <InsightsChartCard height={500}>
                    <LineChart data={chartData} loading={Boolean(busy)} dataKey="DeploymentFailureRate.ComputedFailureRate" yAxisLabel="Failure rate (%)" xAxisDataKey="StartOfInterval" xAxisType="category" yAxisType="number" yAxisDomain={[0, 100]} yAxisTickArray={getEvenlySpacedTickArray(100)} xTickFormatter={dateFormatter} tooltip={<InsightsTooltip showSeries={showSeries} dataKey="DeploymentFailureRate.ComputedFailureRate" valueFormatter={(v) => `${v}%`} cadence={cadence}/>} xAxisTickInterval={insightsCadenceXAxisTickInterval[cadence]} showLegend={showSeries}/>
                </InsightsChartCard>
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
                    <DownloadReportCsvButton report={report}/>
                </div>
            </section>
            <section>
                <FailureRateTrendTables trends={bffResponse.ChangeFailureRate} spaceId={report.SpaceId}/>
            </section>
        </main>);
}
export function InsightsReportDeploymentFailureRatePage({ report }: {
    report: InsightsReportResource;
}) {
    const [reportFilter, setReportFilter] = useReportFilters();
    return (<InsightsReportLayout report={report} reportFilter={reportFilter}>
            <ReportMetricsLayout title="Deployment failure rate" report={report} trendKey="ChangeFailureRate" reportFilter={reportFilter} setReportFilter={setReportFilter}>
                {(props) => <ReportDeploymentFailureRateInner {...props}/>}
            </ReportMetricsLayout>
        </InsightsReportLayout>);
}
